import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next';

const Unauthorized = () => {
    const navigate = useNavigate();
    const handleGoBack = () => navigate('/');
    const [t, ] = useTranslation('global');

    return (
        <section>
            <h1>{t('unauthorized')}</h1>
            <br />
            <p>{t('noAccess')}</p>
            <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
        </section>
    )
}

export default Unauthorized;